import React, { useEffect, useRef, useState } from 'react'

export default function Template({ config, photo, background, filter, className, setRef }) {
  const ref = useRef()
  const [height, setHeight] = useState()
  const template = config.printing_format
  const photoPos = config.photo_positions[0]
  useEffect(() => {
    if (ref.current) {
      setRef(ref)
      setHeight(ref.current.getBoundingClientRect().width * template.height / template.width)
    }
  }, [ref])
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${template.width} ${template.height}`}
      className={`h-full w-full max-w-full ${className}`}
      style={{ height }}>
      <filter id="filter" colorInterpolationFilters="sRGB" dangerouslySetInnerHTML={{ __html: filter }} />
      <image x={photoPos.x} y={photoPos.y} height={photoPos.height} width={photoPos.width} preserveAspectRatio="xMidYMid slice" href={photo} filter="url(#filter)" />
      <image x={0} y={0} height={template.height} width={template.width} preserveAspectRatio="xMidYMid slice" href={background} />
    </svg>
  )
}